import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import BusinessRoutes from "./BusinessRoutes";

const CustomerPrivateRoutes = () => {
  const { isLoggedIn } = useSelector((store) => store.user)
  const group = secureLocalStorage.getItem("group");
  console.log("CustomerPrivateRoutes - group:", group);
  return (
    <>
      {isLoggedIn ? (
        <>

          {group === "Customer" ? (
            <BusinessRoutes isNotAuthRoute={true}/>
          ) : (
            <Navigate to="/account" />
          )}
        </>
      ) : (
        <Navigate to="/account" />
      )}
    </>
  );
};

export default CustomerPrivateRoutes;
